import React from 'react'
import '../Assets/Css/webfooter.css'
import { Col, Container, Row } from 'react-bootstrap'

import { MdKeyboardDoubleArrowRight } from "react-icons/md";
import footerbg from '../Assets/Image/footer-bg.png'

export default function WebFooter() {
  return (
    <>
      <Col lg={12}>
        <div className='p-1' style={{
          backgroundImage: `url(${footerbg})`,
          backgroundSize: 'cover',
          backgroundPosition: 'bottom',
          backgroundRepeat: 'no-repeat',
        }}>
          <Container>
            <Row className='mt-5'>
              <Col lg={5}>
                <h5 className='text-white'>Trident Software Service</h5>
                <p className='text-white'>
                  At Trident Software Services, we empower businesses of every size with intelligent solutions — helping startups scale, enterprises optimize, and operations run smarter.
                </p>
              </Col>
              <Col lg={4} className='justify-content-end'>
                <h5 className='text-light'>Quick Links</h5>
                <ul className='list-unstyled text-white'>
                  <li><MdKeyboardDoubleArrowRight /><a href='/' className='quick-links'>Home</a></li>
                  <li><MdKeyboardDoubleArrowRight /><a href='diversity' className='quick-links'>Diversity</a></li>
                  <li><MdKeyboardDoubleArrowRight /><a href='enterprise' className='quick-links'>Enterprise</a></li>
                  <li><MdKeyboardDoubleArrowRight /><a href='ourproducts' className='quick-links'>Product and Training</a></li>
                  <li><MdKeyboardDoubleArrowRight /><a href='consultants' className='quick-links'>Consultants </a></li>
                </ul>
              </Col>

              <Col lg={3}>
                <h5 className='text-light'>Products</h5>
                <ul className='list-unstyled text-white'>
                  <li><MdKeyboardDoubleArrowRight /><a href='ourproducts' className='quick-links'>CRM Software</a></li>
                  <li><MdKeyboardDoubleArrowRight /><a href='ourproducts' className='quick-links'>Billing Solution</a></li>
                  <li><MdKeyboardDoubleArrowRight /><a href='ourproducts' className='quick-links'>Inventory Manager</a></li>
                  <li><MdKeyboardDoubleArrowRight /><a href='ourproducts' className='quick-links'>HRMS Tools</a></li>
                  <li><MdKeyboardDoubleArrowRight /><a href='ourproducts' className='quick-links'>Custom ERP</a></li>
                </ul>
              </Col>

              {/* <Col lg={3}>
                <h5 className='text-light'>Connect With us</h5>
                <div>
                  <a
                    href="https://wa.me/13122847077"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ textDecoration: 'none', color: 'inherit' }}
                  >
                    <span className='text-white'>
                      <FaMobileAlt color='white' /> +1 (312) 284-7077
                    </span>
                  </a>
                </div>
                <div className='d-flex mt-2'>
                  <a
                    href="mailto:info@tridentsoftwareservice.com"
                    style={{ textDecoration: 'none', color: 'inherit', display: 'inline-flex', alignItems: 'center', gap: '6px' }}
                  >
                    <span className='text-white'>
                      <MdEmail color='white' /> info@tridentsoftwareservice.com
                    </span>
                  </a>
                </div>
                
                <div className='d-flex mt-3'>
                  <a className='iconback' href="#"><FaFacebookF /></a>
                  <a className='iconback mx-2' href="#"><IoLogoYoutube /></a>
                  <a className='iconback mx-1' href="#"><FaInstagram /></a>
                  <a className='iconback mx-1' href="#"><FaXTwitter /></a>
                </div>
              </Col> */}
            </Row>

            <div className='text-white mt-3 footerend text-center'>
              <hr />
              <p>© {new Date().getFullYear()} <span>Trident Software Service </span> |
                <a href="https://www.bighostindia.in/" style={{ color: 'white', textDecoration: 'none' }}> Design By : BigHost India Private Limited</a>
              </p>
            </div>
          </Container>
        </div>
      </Col>
    </>
  )
}
